import { FieldsEditType } from '@systemeio/digital-store-shared'
import {
  BUTTON_BASE_CLASS_NAME as BASE_CLASS_NAME,
  BUTTON_BASE_FLEX_CLASS_NAME as BASE_FLEX_CLASS_NAME,
  ContactFiledInterface,
  FormSelectDataType,
  getContactFieldTitle,
  ListBoxSelect,
} from '@systemeio/ui'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { AddIcon } from '@systemeio/ui'

interface StoreAddFieldProps {
  fields?: ContactFiledInterface[]
  onAdd: (field: FieldsEditType) => void
}

const StoreAddField: FC<StoreAddFieldProps> = ({ fields, onAdd }) => {
  const { t } = useLocoTranslation()
  const data: FormSelectDataType<string>[] | undefined = fields?.map(f => ({
    id: f.slug,
    caption: getContactFieldTitle(f),
  }))

  const disabled = fields?.length === 0

  return (
    <ListBoxSelect
      buttonClassName={'w-fit self-center rounded-lg'}
      value={undefined}
      data={data}
      disabled={disabled}
      onChange={data => {
        if (!data) return
        const field = fields?.find(f => f.slug === data)
        if (field) {
          onAdd({
            fieldName: getContactFieldTitle(field),
            slug: field.slug,
            required: false,
          })
        }
      }}
    >
      {() => (
        <div
          className={twMerge(
            BASE_CLASS_NAME,
            BASE_FLEX_CLASS_NAME,
            'bg-brand-primary text-background-secondary hover:bg-brand-primary-hover px-4',
            disabled && 'bg-text-secondary/50 hover:bg-text-secondary/50',
          )}
        >
          <AddIcon />
          {t('dashboard.store.item.add_field')}
        </div>
      )}
    </ListBoxSelect>
  )
}

export default StoreAddField
